module.exports = __webpack_public_path__ + "img/bg_jidu@2x.c49246fd.png";